import "react-toastify/dist/ReactToastify.css";

import { format } from "date-fns";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Modal from 'react-bootstrap/Modal';
import { v4 } from "uuid";
import * as Yup from "yup";
import {ContainerImages, ContainerTextArea} from "./styles.js";
import ImageSelectRender, {FileType} from "../ImageSelectRender";
import api from "../../../services/api";
import TextAreaForm from "../../TextAreaForm";
import InputForm from "../../InputForm/InputForm";
import {convertMinutesFromMidnightToTimeFormat, minutesFromMidnight} from "../../../utils/time";
import SelectForm from "../../SelectForm/SelectForm";
import Button from "../../Buttons/Button";
import CustomDatePicker from "../../CustomDatePicker";
import chevronLeft from "../../../assets/images/icons/chevron-left.svg";
import TimePicker from "../../TimePicker/TimePicker";
import TopNav from "../../TopNav/TopNav";
import SideBar from "../../SideBar/SideBar";
import RoundedToggleButton from "../../ToggleButton";
import {Label} from "../New/styles";



type Option = {
  value: string | number;
  label: string;
};

export default function EditOffer() {
  const navigate = useNavigate();
  const { offerId } = useParams();

  const { state } = useLocation();
  const offerData:IOffers | undefined = state?.offerData;

  const [subject, setSubject] = useState("");
  const [approvedBy, setApprovedBy] = useState("");

  const [offerImages, setOfferImages] = useState([]);
  const [description, setDescription] = useState("");
  const [totalOffers, setTotalOffers] = useState("");
  const [expirationDate, setExpirationDate] = useState(null);
  const [expirationTime, setExpirationTime] = useState(
    offerData?.expiration_date 
    ? minutesFromMidnight(new Date(offerData.expiration_date))
    : null
  );
  const [isVip, setIsVip] = useState();

  const [memberTypeOptions] = useState([
    { label: 'Everyone', value: 'Everyone' },
    { label: 'Male', value: 'Male' },
    { label: 'Female', value: 'Female' }
  ]);
  const [memberType, setMemberType] = useState(memberTypeOptions[0].value);

  const [listVenues, setListVenues] = useState([]);
  const [selectedVenues, setSelectedVenues] = useState(null);

  const [loading, setLoading] = useState(false);
  const [loadingVenues, setLoadingVenues] = useState(true);

  const [errors, setErrors] = useState({});

  const lastImageId = useRef('');

  useEffect(() => {
    setLoadingVenues(true);


    getVenues();

    setOfferInfo();
  }, []);

  const setOfferInfo = async () => {
    try {
      setSubject(offerData?.subject || '');
      setDescription(offerData?.description || '');
      setTotalOffers(offerData?.total_available?.toString() || '');

      setApprovedBy(offerData?.approved_by || '')

      if (offerData?.member_type) {
        setMemberType(
          `${offerData.member_type.charAt(0).toUpperCase()}${offerData.member_type.toLowerCase().slice(1)}`
        );
      }

      if (offerData?.expiration_date) {
        setExpirationDate(new Date(offerData.expiration_date));
        setExpirationTime(minutesFromMidnight(new Date(offerData.expiration_date)));
      }

      console.log(offerData?.isVip)

      if (offerData?.isVip){
        setIsVip(offerData?.isVip);
      }

      if (offerData?.image_url && !(offerData.image_url.includes('undefined'))) {
        setOfferImages([{
          id: v4(), mediaUrl: offerData.image_url
        }])
      }
    } catch (error) {
      console.log(error);
    }
  }

  const handleToggle = (checked) => {
    setIsVip(checked);
  };

  
  const getVenues = async () => {
    try {
      const response = await api.get(`/venue-owners/venues`, {
        params: {
          records: 99999,
          page: 0,
        },
      });

      setListVenues(response?.data?.data || []);

      if (offerData?.venue_details) {
        setTimeout(() => {
          setSelectedVenues({
            label: offerData.venue_details.name,
            value: offerData.venue_details._id
          })
        }, 200);
      }

      setLoadingVenues(false);
    } catch (error) {
      console.log(`venues get request didn't work. error: ${error}`);
      setLoadingVenues(false);
    }
  };



  const optionsVenus = loadingVenues
    ? []
    : listVenues.map((venue: any) => ({
        value: venue?._id,
        label: venue?.name,
      }));

  const handleCategoryVenues = (selectedOptions: any) => {
    setSelectedVenues(selectedOptions);
  };

  const handleImageAdd = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const file = event.target.files?.[0];

      if (!file) {
        return;
      }

      const mediaUrl = URL.createObjectURL(file);

      if (file) {
        const image:FileType = {
          id: v4(),
          file, mediaUrl
        };

        setOfferImages([image])

        // setOfferImages((oldState) => {
        //   if (oldState.find(i => (i.id === lastImageId.current))) {
        //     const tempState = oldState.map(i => {
        //       if (lastImageId.current === i.id) {
        //         return image
        //       }
  
        //       return i
        //     })

        //     return tempState;
        //   }
          
        //   return [...oldState, image]
        // });
      }
    },
    []
  );

  const handleImageRemove = useCallback((id: string) => {
    setOfferImages((oldState) => {
      const updatedState = oldState.filter((img) => !(img.id === id));
      return updatedState;
    });
  }, []);
  
  const handleMemberTypeChange = (selectedValues: any) => {
    setMemberType(selectedValues ? selectedValues.value : "");
  };

  const handleChangeDescription = (value: string) => {
    setDescription(value);
  };

  const handleDateChange = (date: Date | null) => {
    setExpirationDate(date);
  };
  const handleEndTimeChange = ({ value }: any) => {
    console.log(value);
    
    setExpirationTime(value);
  };

  const validateFields = useCallback(async (data: any) => {
    const shape = Yup.object().shape({
      subject: Yup.string().required('Required field.'),
      // memberType: Yup.string().required('Required field.'),
      venue_id: Yup.string().required('Required field.'),
      expirationDate: Yup.string().required('Required field.'),
      expirationTime: Yup.string().required('Required field.'),
      // totalOffers: Yup.string().required('Required field.'),
      description: Yup.string().required('Required field.'),
      // approvedBy: Yup.string().required('Required field.'),
    });

    await shape.validate(data, { abortEarly: false });
  }, []);

  const handleDelete = async () => {
    if (window.confirm("Are you sure you want to delete this offer?")) {
      try {
        await api.delete(`/offers/${offerId}`);

        toast.success("This offer has been deleted");
  
        navigate("/offers");
      } catch (error) {
        console.log('Error Processing Request ==> ', error);
        toast.error(
          "An error occurred, try again later. If persists, contact system administrator."
        );
      }
      
    }
  }

  const handleEditOffer = async (event) => {
    event.preventDefault();
    try {
      const formattedDate = expirationDate
          ? format(expirationDate, "yyyy-MM-dd")
          : "";
      const formattedTime = (expirationTime !== null && typeof expirationTime === 'number')
          ? convertMinutesFromMidnightToTimeFormat(expirationTime)
          : "";

      console.log(formattedTime);

      const newOffer = {
        subject: subject.trim(),
        expirationDate: formattedDate,
        expirationTime: formattedTime,
        venue_id: selectedVenues?.value,
        description: description.trim(),
        memberType: memberType.trim(),
        approvedBy: approvedBy.trim(),
        isVip: isVip,
      };

      try {
        setLoading(true);

        await validateFields(newOffer);

        if (!offerImages.length) {
          const err = {
            response: {
              data: {
                message: 'Please select an image'
              }
            }
          };
          throw err;
        }

        const formData = new FormData();
        for (const key in newOffer) {
          if (Object.prototype.hasOwnProperty.call(newOffer, key)) {
            formData.append(key, newOffer[key] ?? "");
          }
        }

        if (offerImages.length) {
          formData.append('image', offerImages[0].file || {
            uri: offerImages[0].mediaUrl,
            name: 'image',
            type: 'image/jpeg'
          });
        }

        await api.put(`offers/update/${offerId}`, formData);

        toast.success("Offer Updated Successfully.");
        navigate('/offers');

      } catch (error) {
        console.log(error);

        if (error?.response?.data?.message) {
          toast.error(`${error.response.data.message}`);
        }

        setLoading(false);

        if (error.name === "ValidationError" && error.inner) {
          setErrors(
              error.inner.reduce((errorObj, currentError) => {
                return {
                  ...errorObj,
                  [currentError.path]: currentError.message,
                };
              }, {})
          );
          toast('Validation error: check the fields and try again.', { type: 'info' });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
      <main>
        <TopNav />
        <div className="main-container">
          <SideBar />
          <article
              style={{ width: "100%", display: "flex", justifyContent: "center" }}
          >
            <section className="add-event">
              <div className="d-flex align-items-center justify-content-between gap-2 mb-4">
                <div className="d-flex align-items-center gap-3">
                  <Link to="/offers">
                    <img src={chevronLeft} alt="Back" />
                  </Link>
                  <h1 className="page-title mb-0">Edit Offer</h1>
                </div>

                <Button
                    className="btn-outline-danger"
                    iconifyIconName="solar:trash-bin-minimalistic-outline"
                    onClick={handleDelete}
                >
                  Delete Offer
                </Button>
              </div>

              <form onSubmit={handleEditOffer}>
                <div className="row g-3">
                  <div className="col-sm-6">
                    <SelectForm
                        isLoading={loadingVenues}
                        onChange={handleCategoryVenues}
                        options={optionsVenus}
                        value={selectedVenues}
                        label="Venue"
                        error={errors?.venue_id}
                    />
                  </div>

                  <div className="col-sm-6">
                    <InputForm
                        label="Title"
                        id="Name"
                        onChange={(event) => setSubject(event.target.value)}
                        value={subject}
                        placeholder="Offer title"
                        error={errors?.subject}
                    />
                  </div>

                  <div className="col-6 col-sm-3">
                    <CustomDatePicker
                        label="Valid until"
                        selectedDate={expirationDate}
                        onChange={handleDateChange}
                        error={errors?.expirationDate}
                    />
                  </div>

                  <div className="col-6 col-sm-3 align-self-end">
                    <TimePicker
                        defaultValue={
                          expirationTime !== null
                              ? convertMinutesFromMidnightToTimeFormat(expirationTime)
                              : "00:00"
                        }
                        onChangeTime={handleEndTimeChange}
                    />
                  </div>

                  <div className="col-sm-6">
                    <InputForm
                        label="Approved By"
                        id="approved"
                        onChange={(event) => setApprovedBy(event.target.value)}
                        value={approvedBy}
                        placeholder="Approved By"
                        error={errors?.approvedBy}
                        isDisabled={true}
                    />
                  </div>

                  <div className="col-sm-6">
                    <SelectForm
                        onChange={(selected) => setMemberType(selected?.value)}
                        options={memberTypeOptions}
                        value={memberTypeOptions.find((o) => o.value === memberType) || memberTypeOptions[0]}
                        label="Who can redeem"
                    />
                  </div>

                  <div className="col-12">
                    <ContainerTextArea>
                      <TextAreaForm
                          onChange={handleChangeDescription}
                          value={description}
                          label="Text"
                          placeholder="Description of the offer"
                          error={errors?.description}
                      />
                    </ContainerTextArea>
                  </div>

                  <div className="col-12">
                    <div className="fs-14 fw-bold text-white px-2">Image</div>
                    <div className="pb-2 px-2 fs-13 opacity-75 fst-italic">
                      Note: Only .jpg, .jpeg, .png are allowed
                    </div>
                    <ContainerImages className="d-flex align-items-center gap-3 flex-wrap">
                      {offerImages.map((img) => (
                          <ImageSelectRender
                              key={img.id}
                              onRemove={() => handleImageRemove(img.id)}
                              defaultValue={img.mediaUrl}
                          />
                      ))}

                      {offerImages.length === 0 && (
                          <ImageSelectRender onAdd={handleImageAdd}/>
                      )}
                    </ContainerImages>
                  </div>


                  <div className="col-12">
                    <RoundedToggleButton
                        defaultValue={isVip}
                        onToggle={handleToggle}
                    />
                    <Label style={{padding: "20px"}}>
                      {isVip ? "This is a VIP Offer" : "Add as a VIP Offer"}
                    </Label>
                  </div>


                </div>

                <div className="mt-4">
                  <Button
                      primaryBtn
                      iconifyIconName="ic:round-check"
                      showLoading={loading}
                      type="submit"
                  >
                    Edit Offer
                  </Button>
                </div>
              </form>
            </section>
          </article>
        </div>
      </main>
  );

};
